import React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import OwnerMobileMerchRow from './mobile-row/owner-merch-row';
import OwnerDesktopMerchRow from './desktop-view/owner-merch-row';

import { MerchProduct } from '@services/merch/types/api/merch-product';

declare type CatalogOwnerMerchRowProps = {
  item: MerchProduct;
  isMobile: boolean;
};

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export default connect(mapStateToProps)(function CatalogOwnerMerchRow({
  item,
  isMobile,
}: CatalogOwnerMerchRowProps) {
  return isMobile ? (
    <OwnerMobileMerchRow item={item} />
  ) : (
    <OwnerDesktopMerchRow item={item} />
  );
});
